import axios from "axios";
import { OFFER_ACTION_TYPES } from "./chatbotActionTypes";
import { toast } from "react-hot-toast";

const imgURL = "https://www.visa.co.in/offers/api/offer";

export const fetchImages = (brandId) => async (dispatch) => {
  dispatch({ type: OFFER_ACTION_TYPES.REQUEST });

  // ✅ Validate Brand ID length
  if (!brandId || brandId.length !== 6) {
    const message = "Brand ID must be exactly 6 characters";
    toast(message, { icon: "⚠️" });
    dispatch({ type: OFFER_ACTION_TYPES.FAILURE, payload: message });
    return;
  }

  try {
    const url = `${imgURL}/${brandId}?locale=en_in&siteId=www.visa.co.in`;
    const response = await axios.get(url);
    const data = response?.data;

    if (!data) {
      const message = "No data found";
      toast(message, { icon: "⚠️" });
      dispatch({ type: OFFER_ACTION_TYPES.SUCCESS, payload: { message, status: false } });
      return;
    }

    // Extract URLs and images safely
    const seoUrls = data.seoHrefUrls ?? [];
    const matchedLocaleUrl = seoUrls.find((item) => item.locale === "en_in")?.pageUrl;
    const images = data.imageList?.map((img) => img.fileLocation) ?? [];

    if (!matchedLocaleUrl || images.length === 0) {
      const message = "No valid images found for this brand ID";
      toast(message, { icon: "⚠️" });
      dispatch({ type: OFFER_ACTION_TYPES.SUCCESS, payload: { message, status: false } });
      return;
    }

    // Final structured payload
    const payload = {
      detail_url: matchedLocaleUrl,
      images: images?.[0],
      status: true,
    };

    dispatch({ type: OFFER_ACTION_TYPES.SUCCESS, payload });
  } catch (error) {
    const message = error.message || "Something went wrong";
    toast.error(message);
    dispatch({ type: OFFER_ACTION_TYPES.FAILURE, payload: message });
  }
};
